import React from 'react';
import PropTypes from 'prop-types';

import { StyledContainer, StyledCompletedPart } from './styled';

interface Props {
  color: 'red' | 'blue';
  className?: string;
}

const LoadingBar = ({ className, color }: Props) => (
  <StyledContainer className={className} data-test="loading-bar">
    <StyledCompletedPart color={color} data-test="completed-part" />
  </StyledContainer>
);

LoadingBar.propTypes = {
  color: PropTypes.oneOf(Object.values(['red', 'blue'])).isRequired,
  className: PropTypes.string,
};

export default LoadingBar;
